import * as React from "react";

import Box from "@mui/joy/Box";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import Link from "@mui/joy/Link";

import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export interface Breadcrumb {
  label: string;
  href?: string;
}

interface PageProps {
  children: React.ReactNode;
  breadcrumbs: Breadcrumb[];
}

// TODO: Fix page / sidebar sizing (long page, sidebar doesn't go down)

const Page: React.FC<PageProps> = ({ children, breadcrumbs }) => {
  return (
    <Box sx={{ display: "flex", minHeight: "100dvh", flexDirection: "column" }}>
      <Header />
      <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
        <Sidebar />
        <Box
          component="main"
          className="MainContent"
          sx={{
            px: { xs: 2, md: 6 },
            pt: {
              xs: "calc(12px + var(--Header-height))",
              sm: "calc(12px + var(--Header-height))",
              md: 3,
            },
            pb: { xs: 2, sm: 2, md: 3 },
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            height: "100%", // Stretch to fill available height
            gap: 1,
            overflow: "auto", // Allow scrolling for long content
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Breadcrumbs
              size="sm"
              aria-label="breadcrumbs"
              separator={<ChevronRightRoundedIcon />}
              sx={{ pl: 0 }}
            >
              <Link underline="none" color="neutral" href="/" aria-label="Home">
                <HomeRoundedIcon />
              </Link>
              {breadcrumbs.map((breadcrumb, index) => (
                <Link
                  key={index}
                  underline={breadcrumb.href ? "hover" : "none"}
                  color={breadcrumb.href ? "primary" : "neutral"}
                  disabled={!breadcrumb.href}
                  href={breadcrumb.href}
                  sx={{ fontSize: 12, fontWeight: 500 }}
                >
                  {breadcrumb.label}
                </Link>
              ))}
            </Breadcrumbs>
          </Box>
          <Box
            sx={{
              display: "flex",
              mb: 1,
              gap: 1,
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "start", sm: "center" },
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Page;